import { render, staticRenderFns } from "./SearchSelect.vue?vue&type=template&id=32f70b17&"
import script from "./SearchSelect.vue?vue&type=script&lang=ts&"
export * from "./SearchSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports